//----- Component --------------------------------------------------------/
// Developer :  Daiana Curcio / Nicolas pascucci
// Creation Date :12/06/2024
// Version : 1
// Description : Edición de puntos de venta
//------Changes ----------------------------------------------------------//
// Change Date :
// Change by :
// Change description:
// Change Date :
// Change by :
// Change description:
//========================================================================/
import React, { useState, useEffect } from "react";
import { UrlApi } from "../../../services/apirest";
import {
  Container,
  Grid,
  Box,
  TextField,
  IconButton,
  Button,
  Typography,
  Autocomplete,
  Stack,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { grey } from "@mui/material/colors";
import { logEventos } from "../../../services/services";
//notificacion
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function EditarPuntoVenta(props) {
  const [datosPuntoVenta, setDatosPuntoVenta] = useState(props.datos);
  const [disBtn, setDisBtn] = useState(false);

  //Notification
  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [disabled, setDisabled] = useState(false)

  useEffect(() => {
    setDatosPuntoVenta({
      ...props.datos,
    });
  }, [props.datos]);

  const handleClose = () => {
    return props.editar(false), props.tabla(true), props.actualizar(1);
  };

  /*   GET     */
  const [sucursal, setSucursal] = useState("");
  const [sucursalSeleccionada, setSucursalSeleccionada] = useState("");

  const obtenerSucursales = () => {
    fetch(UrlApi + "/sucursales")
      .then((data) => data.json())
      .then((data) => setSucursal(data));
  };
  useEffect(() => {
    obtenerSucursales();
  }, []);
  const [puntoVenta, setPuntoVenta] = useState();

  const obtenerPuntoVenta = () => {
    fetch(UrlApi + "/puntos_venta")
      .then((data) => data.json())
      .then((data) => setPuntoVenta(data));
  };
  useEffect(() => {
    obtenerPuntoVenta();
  }, []);

  const [empresas, setEmpresas] = useState()
  const [empresaSeleccionada, setEmpresaSeleccionada] = useState("")
  const obtenerEmpresas = () => {
    fetch(UrlApi + "/empresas")
      .then((data) => data.json())
      .then((data) => setEmpresas(data));
  };
  useEffect(() => {
    obtenerEmpresas();
  }, []);
  // console.log("DATOS PUNTO VENTA EDITAR", props.datos);
  // console.log("SUCURSAL SELECCIONADA DE EDITAR", sucursalSeleccionada);

  //Funcion para guardar
  const guardarEditar = async (e) => {
    logEventos(
      "Guardar edición del punto de venta",
      "puntos de venta",
      "Se guardo la edición",
      localStorage.getItem("user")
    );
    setDisabled(true);
    e.preventDefault();
    const response = await fetch(
      UrlApi + "/puntos_venta/" + datosPuntoVenta.id_punto,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          // id_sucursal: sucursalSeleccionada.id,
          empresa: empresaSeleccionada.idempresa,
          usuario: localStorage.getItem("user"),
        }),
      }
    )
      .then((res) => {
        if (!res.err) {
          setOpenSnack(true);
          // PONGO EL UPDATE EN TRUE PARA QUE LA TABLA SE ACTUALICE CON CADA ACTUALIZACION EN LOS DATOS
          setColorMensaje("#D4EFDF");
          setMensaje("Se guardó exitosamente !");
          console.log("Guardado");
        } else {
          setOpenSnack(false);
          setColorMensaje("#F1948A");
          setMensaje("Error al guardar");
          console.log("Error");
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const [repetido, setRepetido] = useState(false);
console.log("datos", datosPuntoVenta);

  useEffect(() => {
    if (empresaSeleccionada.idempresa !== datosPuntoVenta.empresa) {
      if (puntoVenta) {
        // Buscar el punto de venta que coincida con datosPuntoVenta.id_punto
        const puntoVentaRepetido = puntoVenta.find(
          (pv) => pv.id_punto === datosPuntoVenta.id_punto && pv.empresa === empresaSeleccionada.idempresa
        );
      // console.log("REPEEE", puntoVentaRepetido);

        // Actualizar el estado solo si se encuentra un punto de venta repetido
        if (puntoVentaRepetido) {
          setRepetido(true);
        } else {
          setRepetido(false);
        }
      }
      console.log("lo hizo");
      
    }else {
      setRepetido(false)
    }
  }, [puntoVenta, empresaSeleccionada]);

  const style = {
    backgroundColor: "#ffffff",
    width: "100%",
  };

  useEffect(() => {
    if (sucursal) {
      const sucursalEncontrada = sucursal.find(
        (s) => s.id === datosPuntoVenta.id_sucursal
      );
      setSucursalSeleccionada(sucursalEncontrada);
    }
  }, [datosPuntoVenta.id_sucursal, sucursal]);

  useEffect(() => {
    if (empresas) {
      const empresaEncontrada = empresas.find(
        (s) => s.idempresa === datosPuntoVenta.empresa
      );
      setEmpresaSeleccionada(empresaEncontrada);
    }
  }, [datosPuntoVenta.empresa, empresas]);
console.log(empresaSeleccionada);

  //--------------------------- NOTIFICACION----------------------------------------------//
  //Snackbar Notificacion
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
    handleClose();
  };

  useEffect(() => {
    if (repetido === true) {
      setDisabled(true)
    } else {
      setDisabled(false)
    }
  }, [repetido])
  

  return (
    <div>
      <Container>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container backgroundColor="#1F618D" p={1.5}>
            <Grid item xs={2}>
              <IconButton onClick={handleClose}>
                <ArrowBackIcon sx={{ color: grey[50] }} />
              </IconButton>
            </Grid>
            <Grid
              item
              xs={8}
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
            >
              <Typography variant="h5" color="#ffffff">
                Editar Punto de Venta
              </Typography>
            </Grid>
          </Grid>
        </Box>
        <form onSubmit={guardarEditar} autoComplete="off">
          <Box
            backgroundColor="#F4F6F6"
            mt={2}
            p={3}
            border={0.5}
            borderColor={"#ABB2B9"}
            borderRadius={4}
          >
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              spacing={2}
            >
              {/* <Grid item xs={6}>
                <Autocomplete
                  disableClearable
                  value={sucursalSeleccionada}
                  clearOnEscape
                  defaultValue={sucursalSeleccionada || null}
                  onChange={(event, value) => {
                    setSucursalSeleccionada(value);
                  }}
                  options={sucursal}
                  isOptionEqualToValue={(option, value) =>
                    option.valueOf === value || value === ""
                  }
                  getOptionLabel={(sucursal) =>
                    `${sucursal.id} - ${sucursal.nombre}`
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      focused
                      style={style}
                      fullWidth
                      placeholder="Tipee para buscar sucursal.."
                      variant="outlined"
                      size="small"
                      label="Sucursal"
                    />
                  )}
                />
              </Grid> */}
              <Grid item xs={6}>
                <Autocomplete
                  disableClearable
                  value={empresaSeleccionada || null}
                  clearOnEscape
                  defaultValue={empresaSeleccionada || null}
                  onChange={(event, value) => {
                    setEmpresaSeleccionada(value);
                  }}
                  options={empresas}
                  isOptionEqualToValue={(option, value) =>
                    option.valueOf === value || value === ""
                  }
                  getOptionLabel={(empresa) =>
                    `${empresa.idempresa} - ${empresa.empresa}`
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      focused
                      style={style}
                      fullWidth
                      placeholder="Tipee para buscar empresa.."
                      variant="outlined"
                      size="small"
                      label="Empresa"
                      error={repetido?true:false}
                      helperText={
                        repetido === true
                          ? "El Número de Punto de Venta ya Existe en la Empresa"
                          : ""
                      }
                    />
                  )}
                />
              </Grid>
            </Grid>

            <Grid
              container
              justifyContent="space-between"
              alignItems="flex-end"
              mt={2}
            >
              <Button variant="contained" onClick={handleClose} color="error">
                Volver
              </Button>

              <Button
                disabled={disabled}
                variant="contained"
                type="submit"
                color="success"
              >
                Guardar Edición
              </Button>
            </Grid>
          </Box>
        </form>
        {/* SNACKBAR QUE SE MOSTRARA AL GUARDAR LOS CAMBIOS */}
        <Stack spacing={2} sx={{ width: "100%" }}>
          <Snackbar
            open={openSnack}
            autoHideDuration={1500}
            onClose={handleCloseSnack}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <Alert
              onClose={handleCloseSnack}
              severity="success"
              sx={{ width: "100%" }}
              style={{ backgroundColor: colormensaje, color: "black" }}
            >
              {mensaje}
            </Alert>
          </Snackbar>
        </Stack>
      </Container>
    </div>
  );
}

export default EditarPuntoVenta;
